var isProduction = process.env.NODE_ENV === 'production';
var cache = {};
export function deprecate(message, condition) {
  if (!isProduction && !cache[message] && condition) {
    cache[message] = true;
    /* eslint-disable-next-line no-console */

    console.warn('VCC UI Deprecation Notice:\n', message);
  }
}